// extracted by mini-css-extract-plugin
export var convert_list_box = "convert-case-module--convert_list_box--d3c5b";
export var copy_message = "convert-case-module--copy_message--8349c";
export var download_copy_btn = "convert-case-module--download_copy_btn--4f348";
export var file_input = "convert-case-module--file_input--0db11";
export var input_file_upload = "convert-case-module--input_file_upload--818f4";
export var selected = "convert-case-module--selected--38ae9";
export var text_field = "convert-case-module--text_field--2b750";
export var wideText = "convert-case-module--wide-text--19d19";